import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "../lib/api";
import { toast } from "sonner";
import { EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error("Could not send reset email — please try again");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-16 grid-bg">
      <div className="w-full max-w-md surface border border-white/10 p-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-primary-yellow font-bold">Reset Password</div>
        <h1 className="font-heading text-4xl uppercase font-black mt-2">Forgot password?</h1>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-8 text-center">
            <EnvelopeSimple size={48} weight="duotone" className="text-primary-yellow mx-auto" />
            <p className="text-white/80 mt-4 text-sm">If an account exists for <span className="text-primary-yellow font-mono-num">{email}</span>, a reset link is on its way. Check your inbox (and spam folder).</p>
            <p className="text-white/40 text-xs mt-4 uppercase tracking-widest">Link expires in 1 hour</p>
            <Link to="/login" className="mt-8 inline-block w-full border border-white/20 uppercase tracking-[0.2em] font-bold py-3 text-sm hover:border-primary-yellow hover:text-primary-yellow transition-colors">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
            <p className="text-white/60 text-sm">Enter your email and we'll send you a reset link.</p>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full bg-[#0B0D11] border border-white/10 px-4 py-3 focus:border-primary-yellow focus:outline-none focus:ring-1 focus:ring-primary-yellow font-mono-num"
            />
            <button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-primary-yellow text-black font-bold uppercase tracking-[0.2em] py-4 text-sm hover:-translate-y-0.5 transition-transform disabled:opacity-50"
            >
              {loading ? "Sending…" : "Send Reset Link"}
            </button>
            <div className="text-sm text-white/60 text-center">
              <Link to="/login" className="text-primary-yellow hover:underline">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
